import ModalCustomDefault from '../../components/modal/ModalCustomDefault';
import InputNormal from '../input/InputNormal';
import ButtonGroup from '../../components/button/ButtonGroup';
import { styled, Box, Checkbox, Typography } from '@mui/material';
import { d_flex_center, dir_column, d_flex, d_flex_space_between } from '../../styles/common';
import { RiRefreshFill } from 'react-icons/ri';
import { AiFillLock, AiFillUnlock } from 'react-icons/ai';
import { BsChevronRight, BsChevronLeft } from 'react-icons/bs';

import React, { Fragment, useState, useEffect, useRef, useContext } from 'react';
import { fetchGetApi, fetchPostApi } from '../../utils/api';
import { setLocaleDateString, beforeUnLoadFunction } from '../../utils/tools';
import { RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import ModalCheckPw from './ModalCheckPW';
import ModalSelect from './ModalSelect';
import { ModalContext } from '../../provider/ModalProvider';
import { SET_FREE_END_USER, SET_USER } from '../../store/model/user';
import ok_mp3 from '../../../src/assets/audio/ok.mp3';
import fail_mp3 from '../../../src/assets/audio/fail.mp3';
import { SET_TUTORIAL } from '../../store/common/tutorial';

import Inko from 'inko';

const StyledModalPcContainer = styled(Box)<{ fullScreen: string }>(props => {
  const full_screen = props.fullScreen;
  let width = '48rem';
  let height = '42.5rem';
  if (full_screen == 'true') {
    width = '100vw';
    height = 'calc(100vh - 3.5rem)';
  }
  return {
    width,
    height,
    padding: '1.571rem 3.25rem 2.571rem',
    backgroundColor: props.theme.palette.white.main,
    position: 'relative',
  };
});

const StyledLogoWrapper = styled(Box)(props => ({
  height: '6.35rem',
  overflow: 'hidden',
  marginBottom: '1.5rem',
  ...d_flex_center,
  ...dir_column,
}));

const StyledNowWrap = styled(Box)(props => ({
  fontSize: '1.725rem',
  height: '40%',
  color: '#5b5b5b',
  svg: {
    marginLeft: '0.125rem',
    fontSize: '2.2rem',
  },
  ...d_flex_center,
}));

const StyledInputWrap = styled(Box)(props => ({
  height: '5.611rem',
  marginBottom: '0.85rem',
  backgroundColor: '#f7f7f7',
  borderRadius: '0.55rem',
  '& > div': {
    height: '100%',
    '& > div': {
      height: '100%',
      input: {
        textAlign: 'center',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        letterSpacing: '5px',
        '&:focus': {
          fontSize: '3.5rem',
          '&::placeholder': {
            fontSize: '0rem',
          },
        },
        '&::placeholder': {
          fontSize: '1.5rem',
          letterSpacing: '1px',
          color: '#dcdcdc !important',
          fontWeight: '400',
          // lineHeight: '5.611rem !important',
        },
      },
    },
  },

  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#f1f1f1 !important',

    '&:focus-visible': {
      borderColor: '#f1f1f1',
    },
  },

  '&:hover': {
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#f1f1f1',
    },
  },

  '&.Mui-focused': {
    borderWidth: '1px',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#f1f1f1',
    },
  },
}));

const StyledListContainer = styled(Box)(props => ({
  height: 'calc(100% - 8.961rem)',
}));

const StyledButtonWrapper = styled(Box)(props => ({
  height: '3.75rem',
}));

const StyledListWrapper = styled(Box)(props => ({
  width: '50%',
  height: '100%',
  padding: '1rem 0 0 0',

  flexWrap: 'wrap',
  alignContent: 'flex-start',
  overflowY: 'auto',
  ...d_flex,
}));

const ListSliderWrap = styled(Box)(props => ({
  width: '200%',
  height: '100%',
  transition: '0.4s ease-in-out',
  display: 'flex',

  '&.right': {
    marginLeft: '-100%',
  },
}));

interface StyledWrapDirection {
  direction: string;
}

const StyledWrap = styled(Box)<StyledWrapDirection>(props => {
  const direction_style =
    props.direction === 'left'
      ? {
          width: '33%',
          justifyContent: 'flex-end',
        }
      : props.direction === 'right'
      ? {
          width: '28%',
          justifyContent: 'flex-start',
        }
      : {
          width: '39%',
        };
  return {
    fontSize: '1.25rem',
    lineHeight: '2rem',
    height: '2rem',
    justifyContent: 'center',
    alignItems: 'center',
    ...d_flex,
    ...direction_style,
  };
});

interface StyledDirectionProps {
  direction: string;
}

const StyledTopWrap = styled(Box)(props => ({
  width: '100%',
  height: 'auto',
  position: 'absolute',
  left: '0',
  top: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  padding: '0 1rem',
  minHeight: '2rem',
}));

const StyledTopBox = styled(Box)<StyledDirectionProps>(props => {
  const direction_style =
    props.direction === 'left'
      ? {
          fontWeight: '400',
          fontSize: '1.1rem',
          color: '#d6d6d6',
          svg: {
            fontSize: '1.625rem',
          },
          display: 'flex',
          alignItems: 'flex-end',
        }
      : {
          fontSize: '1.2rem',
          color: '#d6d6d6',
          svg: {
            fontSize: '1.125rem',
            fontWeight: 'bold',
            alignSelf: 'center',
          },
        };
  return {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'flex-end',
    ...direction_style,
  };
});

const StyledSettingContainer = styled(Box)(props => ({
  width: '50%',
  height: '100%',
  overflow: 'hidden',

  '.mode-box': {
    width: '100%',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',

    '.MuiCheckbox-root': {
      padding: 0,
    },
  },
}));

const SliderWrap = styled(Box)(props => ({
  width: 'calc(200% + 3.25rem)',
  height: 'calc(100% - 6.85rem)',
  display: 'flex',
  flexDirection: 'row-reverse',
  gap: '3.25rem',
  transition: '0.4s ease-in-out',

  '&.slide': {
    marginLeft: 'calc(-100% - 3.25rem)',
  },
}));

const StyledSettingTitle = styled(Box)(props => ({
  width: '100%',
  height: '3.75rem',
  fontSize: '1.25rem',
  backgroundColor: '#f3f3f3',
  color: props.theme.palette.gray_1.main,
  borderTopLeftRadius: '0.75rem',
  borderTopRightRadius: '0.75rem',
  ...d_flex_center,
}));

const StyledSettingBoxWrapper = styled(Box)(props => ({
  height: 'calc(100% - 3.75rem)',
  border: `1px solid ${props.theme.palette.gray_3.main}`,
}));

const StyledSettingBox = styled(Box)(props => ({
  height: '33.33%',
  padding: '1rem 2.5rem',
  borderBottom: `1px solid ${props.theme.palette.gray_3.main}`,
  ...d_flex_space_between,
  '&:last-of-type': {
    borderBottom: 'none',
  },
}));

const StyledSetting = styled(Box)<StyledDirectionProps>(props => {
  const direction_style =
    props.direction === 'left'
      ? {
          width: 'calc(100% - 13rem)',
          marginRight: '1rem',
        }
      : {
          width: '12rem',
        };
  return {
    ...direction_style,
  };
});

const StyledTopSetting = styled(Box)(props => ({
  fontSize: '1.1rem',
  color: '#cdcdcd',
  cursor: 'pointer',
  fontWeight: '400',
  svg: {
    marginTop: '-2px',
    fontSize: '1.25rem',
    marginLeft: '0.25rem',
    fontWeight: 'bold',
    alignSelf: 'center',
  },
  display: 'flex',
  alignItems: 'flex-end',
}));

interface AttendanceListType {
  uname: string;
  rname: string;
  time: string;
  pkid: number;
  no: number;
  uid: number;
  starttime: string | null;
  endtime: string | null;
  rid: number;
  memno: string;
}

interface SettingType {
  title: string;
  subtitle: string;
  value: boolean;
}

interface StorageData {
  reload: boolean;
  lock: boolean;
  alarm: boolean;
}

interface ModalPropsType {
  visible: boolean;
  onClose: () => void;
}

function ModalPc(props: ModalPropsType) {
  const dispatch = useDispatch();
  const user_info = useSelector((state: RootState) => state.UserReducer);
  const tutorial_info = useSelector((state: RootState) => state.TutorialReducer);
  const { modal_alert } = useContext(ModalContext);

  const cur_type = useRef('');
  const [isSetting, setIsSetting] = useState(false);
  const [attendanceNumber, setAttendanceNumber] = useState('');
  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [currentTime, setCurrentTime] = useState('');
  const [apiInterval, setApiInterval] = useState<null | NodeJS.Timeout>(null);
  const [startStudentList, setStartStudentList] = useState<AttendanceListType[]>([]);
  const [endStudentList, setEndStudentList] = useState<AttendanceListType[]>([]);
  const [updateLock, setUpdateLock] = useState(false);
  const [attendanceStatus, setAttendanceStatus] = useState(false);
  const [savedData, setSavedData] = useState<StorageData>({
    reload: true,
    lock: true,
    alarm: true,
  });
  const [modalSelectContents, setModalSelectContents] = useState<ModalSelectDataType>({
    visible: false,
    data: {
      modal_id: '',
      title: '',
      subtitle: '',
      type: '',
      contents: [],
    },
    currentInput: [],
  });
  const [defaultSettings, setDefaultSettings] = useState<SettingType[]>([
    {
      title: '새로 고침',
      subtitle: 'PC 출결 내역을 실시간 새로고침(10초 간격)합니다.',
      value: true,
    },
    {
      title: '화면 잠금',
      subtitle: 'PC 출석체크 화면의 잠금 아이콘을 활성화 합니다.',
      value: true,
    },
    {
      title: '소리 설정',
      subtitle: '출결번호 입력 후 띵동~ 효과음을 제어합니다.',
      value: true,
    },
  ]);
  const [selectedButton, setSelectedButton] = useState('left');
  const visible = props.visible;
  const onCloseModal = props.onClose;
  const [fullScreen, setFullScreen] = useState(false);

  function handleFocus() {
    const user = sessionStorage.getItem('user');
    if (!user) {
      modal_alert.openModalAlert('logout_using_modal_pc', undefined, () => {
        window.removeEventListener('beforeunload', beforeUnLoadFunction);
        sessionStorage.removeItem('mode');
        window.close();
      });

      return;
    }
  }

  function handleBlur() {
    const check_pc = localStorage.getItem('check_pc');
    if (check_pc) {
      const check_pc_json = JSON.parse(check_pc);
      if (check_pc_json['lock'] == true) {
        modal_alert.openModalAlert('using_modal_pc');
      }
    }
  }

  useEffect(() => {
    if (visible) {
      const cur_mode = sessionStorage.getItem('mode');
      if (cur_mode && cur_mode == 'attendance') {
        setFullScreen(true);

        setTimeout(() => {
          const modal_el = document.getElementById('modal_default_container');
          if (modal_el && modal_el.children[0]) {
            modal_el.style.borderRadius = '0px';
            modal_el.children[0].setAttribute('style', 'border-radius: 0px');
          }

          window.onfocus = handleFocus;
          window.onblur = handleBlur;
        }, 0);
      }

      setSettings();
      getAttendanceList('starttime');
      getAttendanceList('endtime');
      setSelectedButton('left');

      // if (tutorial_info.status == 1 && tutorial_info.t4 == 0) {
      //   dispatch({
      //     type: SET_TUTORIAL,
      //     payload: {
      //       t4: 1,
      //     },
      //   });
      //   fetchPostApi(`/${user_info.cid}/user/${user_info.uid}/academy/tutorial`, { t4: 1 });
      // }
    } else {
      if (apiInterval) {
        clearInterval(apiInterval);
      }
      setApiInterval(null);
      setIsSetting(false);
      setAttendanceNumber('');
    }
  }, [visible]);

  const setSettingMethod = (index: number, value: boolean, updateLock?: boolean) => {
    if (index == 0) {
      if (apiInterval) {
        clearInterval(apiInterval);
      }

      if (value) {
        const tmp_api_interval = setInterval(() => {
          getAttendanceList('starttime');
          getAttendanceList('endtime');
        }, 10000);

        setApiInterval(tmp_api_interval);
      } else {
        setCurrentTime(setDateKor(new Date()));
        const tmp_api_interval = setInterval(() => {
          const now = setDateKor(new Date());
          setCurrentTime(now);
        }, 10000);

        setApiInterval(tmp_api_interval);
      }
    } else if (index == 1 && !value && defaultSettings[index].value) {
      setUpdateLock(true);
      setPasswordModalVisible(true);
    }
  };

  const setDateKor = (now: Date) => {
    const date = setLocaleDateString(now, 'kor');

    let hours: number | string = now.getHours();
    let format = '';
    if (user_info.usehourformat == 1) {
      if (hours > 12) {
        hours = hours - 12;
        if (hours < 10) {
          hours = '0' + hours;
        }
      } else {
        hours = hours < 10 ? '0' + hours : hours;
      }

      if (Number(new Date().getHours()) >= 12) {
        format = 'PM ';
      } else {
        hours = [0].includes(Number(hours)) ? 12 : hours;
        format = 'AM ';
      }
    }
    const minutes = now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes();

    return `${date} ${format}${hours}:${minutes}`;
  };

  const setSettings = () => {
    const storage = window.localStorage;
    let storage_data: StorageData = {
      reload: true,
      lock: true,
      alarm: true,
    };

    const check_data = storage.getItem('check_pc');
    if (!check_data) {
      storage_data = {
        reload: true,
        lock: true,
        alarm: true,
      };
      storage.setItem('check_pc', JSON.stringify(storage_data));
    } else {
      const saved_data: StorageData = JSON.parse(check_data);
      storage_data = saved_data;

      const tmp_settings = [...defaultSettings];
      tmp_settings[0].value = saved_data.reload;
      tmp_settings[1].value = saved_data.lock;
      tmp_settings[2].value = saved_data.alarm;
      setDefaultSettings([...tmp_settings]);
    }
    setSettingMethod(0, storage_data.reload);
    setSavedData(storage_data);
  };

  const onClickNaviButton = () => {
    setIsSetting(!isSetting);
    setAttendanceNumber('');
  };

  const getAttendanceList = async (type: string) => {
    cur_type.current = type;

    const get_res = await fetchGetApi(
      `/${user_info.cid}/user/${user_info.uid}/attendance/list?date=${setLocaleDateString(new Date(), '-')}&type=${
        cur_type.current
      }&format=${user_info.usehourformat == 0 ? 'HH' : 'h'}&stdtime=${user_info.stdtime}`,
    );

    const list: AttendanceListType[] | 'null' = get_res.message.result;
    if (list == 'null') {
      if (type == 'starttime') {
        setStartStudentList([]);
      } else {
        setEndStudentList([]);
      }
    } else {
      let tmp_list = [...list];
      if (user_info.usehourformat) {
        let time_type: 'starttime' | 'endtime' = 'starttime';
        if (type == 'endtime') {
          time_type = 'endtime';
        }
        tmp_list = [...tmp_list].map(item => {
          const cur_time = new Date(`1001-01-01 ${item.time}:00`);
          let hour = cur_time.getHours() < 10 ? `0${cur_time.getHours()}` : cur_time.getHours();
          hour = [0].includes(Number(hour)) ? 12 : hour;
          const minutes = cur_time.getMinutes() < 10 ? `0${cur_time.getMinutes()}` : cur_time.getMinutes();
          return {
            ...item,
            time:
              new Date(`1001-01-01 ${item[time_type]}`).getHours() >= 12
                ? `PM ${hour}:${minutes}`
                : `AM ${hour}:${minutes}`,
          };
        });
      }
      if (type == 'starttime') {
        setStartStudentList([...tmp_list]);
      } else {
        setEndStudentList([...tmp_list]);
      }
    }
    const cur_time: string = get_res.message.time;
    if (user_info.usehourformat == 1) {
      const splited_time = `${cur_time}`.split(' ');
      let time = splited_time[splited_time.length - 1];
      const hours = Number(time.split(':')[0]) < 10 ? `0${time.split(':')[0]}` : time.split(':')[0];
      const minutes = time.split(':')[1];

      time = `${hours}:${minutes}`;
      splited_time[splited_time.length - 1] = time;

      const cur_date = `${cur_time}`
        .split('일')[0]
        .replaceAll(' ', '')
        .replace(/[^0-9]/g, '-');
      setCurrentTime(setDateKor(new Date(`${cur_date} ${time}:00`)));
    } else {
      setCurrentTime(cur_time);
    }
  };
  const checkPassword = async (password: string) => {
    if (password.length == 0) {
      modal_alert.openModalAlert('write_password');
      return;
    }

    const inko = new Inko();
    const data = {
      id: user_info.uloginid,
      pwd: password,
      pwdKr: inko.en2ko(password),
      pwdEn: inko.ko2en(password),
    };

    const check_res = await fetchPostApi(`/${user_info.cid}/user/${user_info.uid}/check/password`, data);
    if (check_res.pass) {
      if (!updateLock) {
        onCloseModal();
      } else {
        onClickSettingButton('right', undefined, 1);
      }
      setPasswordModalVisible(false);
    } else {
      modal_alert.openModalAlert('check_password');
    }
  };

  const clearModalSelect = () => {
    setModalSelectContents({
      visible: false,
      data: {
        modal_id: '',
        title: '',
        subtitle: '',
        type: '',
        contents: [],
      },
      currentInput: [],
    });
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const check = /^[0-9]+$/; // 숫자만 입력받은 후에
    if (e.target.value.length >= 0 && e.target.value.length <= 6) {
      if (check.test(e.target.value) || e.target.value === '') {
        const new_value = e.target.value.trim() === '' ? '' : e.target.value;
        setAttendanceNumber(new_value);
      }
    }
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && attendanceNumber && !attendanceStatus) {
      handleAttendanceStatus('start').then(async () => {
        const multi_check_res = await fetchPostApi(`/${user_info.cid}/user/${user_info.uid}/class/multi`, {
          memno: attendanceNumber,
        });
        const classes: { rname: string; rid: number }[] = multi_check_res.message;
        if (typeof classes == 'string') {
          let alert_type = '';
          if (classes == 'no student') {
            alert_type = 'check_memno';
          } else {
            alert_type = 'check_rooms';
          }
          modal_alert.openModalAlert(alert_type);
          setAttendanceNumber('');
          setAttendanceStatus(false);
        } else if (classes.length == 1) {
          sendAttendance(classes[0].rid, classes[0].rname);
        } else {
          setModalSelectContents({
            visible: true,
            data: {
              ...modalSelectContents.data,
              title: '클래스 선택',
              contents: [...classes.map(item => ({ name: item.rname, id: item.rid }))],
              type: 'radio',
              modal_id: 'multi_class_modal',
            },
            currentInput: [],
          });
        }
      });
    }
  };

  const handleAttendanceStatus = (type: string) => {
    return new Promise((resolve, reject) => {
      if (type == 'start') {
        setAttendanceStatus(true);
      } else {
        setAttendanceStatus(false);
      }

      resolve(true);
    });
  };

  const sendAttendance = async (rid: number, rname: string) => {
    const data = {
      type: null,
      memno: attendanceNumber,
      alimtalkuse: user_info.alimtalkuse,
      smsok: user_info.smsok,
      rid,
      rname,
    };

    const send_res = await fetchPostApi(`/${user_info.cid}/user/${user_info.uid}/attendance/send/memno`, data);
    let audio_type = ok_mp3;
    if (send_res.pass) {
      // 체험하기 전용
      // 체험하기 기간 끝나면 지우도록
      if (user_info.pretest == 1) {
        let cur_button = '';
        if (selectedButton == 'right') {
          cur_button = 'left';
        } else {
          cur_button = 'right';
        }

        setSelectedButton(cur_button);
        setAttendanceNumber('');
        setAttendanceStatus(false);
        return;
      }

      if (send_res.is_update) {
        setSelectedButton('right');
      } else {
        setSelectedButton('left');
      }
      getAttendanceList('starttime');
      getAttendanceList('endtime');

      if (send_res.attendancecount && send_res.maxattendancecount) {
        modal_alert.openModalAlert(
          'check_attendance_count',
          `${send_res.maxattendancecount}회 중 잔여 ${send_res.attendancecount}건`,
        );
      }

      if (user_info.attendancesms == '1') {
        const new_academy_info = await fetchGetApi(`/${user_info.cid}/user/${user_info.uid}/academy/info`);
        const smscnt = new_academy_info.message.smscnt;
        const attendancesms = new_academy_info.message.attendancesms;

        dispatch({
          type: SET_USER,
          payload: {
            smscnt,
            attendancesms,
          },
        });
      }
    } else {
      let alert_type = '';
      if (send_res.message == 'already attendance') {
        alert_type = 'already_attendance';
      } else if (send_res.message == 'unabled time') {
        alert_type = 'unabled_time';
      } else if (send_res.message == 'no student') {
        alert_type = 'check_memno';
      } else {
        alert_type = 'free_use_all_cnt';
      }
      if (alert_type == 'free_use_all_cnt') onCloseModal();
      modal_alert.openModalAlert(
        alert_type,
        undefined,
        alert_type == 'free_use_all_cnt'
          ? () => {
              const type = SET_FREE_END_USER;
              dispatch({
                type,
              });
            }
          : undefined,
      );
      audio_type = fail_mp3;
    }
    if (savedData.alarm) {
      const audio: HTMLAudioElement = new Audio(audio_type);
      audio.play();
    }
    setAttendanceNumber('');
    setAttendanceStatus(false);
  };

  const onClickListButton = (direction: string) => {
    setSelectedButton(direction);
  };

  const onClickSettingButton = (direction: string, default_type?: string, index?: number) => {
    if (index || index === 0) {
      const value = direction == 'left' ? true : false;
      const tmp_settings = [...defaultSettings];
      const tmp_storage_data = { ...savedData };

      if (index == 0) {
        tmp_settings[index].value = value;
        tmp_storage_data.reload = value;
      } else if (index == 1) {
        if (value) {
          tmp_settings[index].value = value;
          tmp_storage_data.lock = value;
          setUpdateLock(false);
        } else {
          if (updateLock) {
            tmp_settings[index].value = value;
            tmp_storage_data.lock = value;
            setUpdateLock(false);
          }
        }
      } else if (index == 2) {
        tmp_settings[index].value = value;
        tmp_storage_data.alarm = value;
      }
      setDefaultSettings([...defaultSettings]);
      setSettingMethod(index, value);
      setSavedData(tmp_storage_data);
      window.localStorage.setItem('check_pc', JSON.stringify(tmp_storage_data));
    }
  };

  const checkClose = () => {
    if (user_info.memtype === 'F') {
      onCloseModal();
      return;
    }
    if (savedData.lock && user_info.pretest == 0) {
      setPasswordModalVisible(true);
    } else {
      onCloseModal();
    }
  };

  const checkClassId = (value: ModalSelectContentsType[]) => {
    sendAttendance(Number(value[0].id), value[0].name);
  };

  const onCancelSelectModal = () => {
    setAttendanceStatus(false);
  };

  const openFullScrren = () => {
    if (!fullScreen) {
      window.open(
        '/?mode=attendance',
        'attendanceonline',
        `fullscreen=yes, resizable=no, scrollbars=no, width=${screen.width}, height=${screen.height}`,
      );
    }
  };

  return (
    <>
      <ModalCustomDefault
        title={'PC 출석체크'}
        visible={visible}
        onClose={checkClose}
        useBlur={false}
        useHeaderButton={!fullScreen}
      >
        <StyledModalPcContainer fullScreen={`${fullScreen}`}>
          {isSetting ? (
            <StyledTopWrap>
              <StyledTopSetting onClick={onClickNaviButton}>
                <BsChevronLeft /> 출석
              </StyledTopSetting>
            </StyledTopWrap>
          ) : (
            <StyledTopWrap>
              <StyledTopBox direction='left'>
                {savedData.lock ? <AiFillLock /> : <AiFillUnlock />}
                <Box component={'span'}>잠금</Box>
              </StyledTopBox>
              <StyledTopBox direction='right' onClick={onClickNaviButton}>
                Settings <BsChevronRight />
              </StyledTopBox>
            </StyledTopWrap>
          )}
          <StyledLogoWrapper>
            <Box
              sx={{
                fontSize: '2rem',
                height: '60%',
                ...d_flex_center,
                gap: '0.5rem',
                fontFamily:
                  'OSeongandHanEum, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important',
                fontWeight: '600',
                letterSpacing: '-1px',
              }}
            >
              <Box
                component='img'
                src='https://kr.object.ncloudstorage.com/cdn-irontrain/common/images/checkbus_V2_logo.png'
                sx={{ maxHeight: '90%' }}
              />
              스마트 출결
            </Box>
            <StyledNowWrap>
              {currentTime}
              <RiRefreshFill
                color='#bcbcbc'
                style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
                onClick={() => {
                  getAttendanceList('starttime');
                  getAttendanceList('endtime');
                }}
              />
            </StyledNowWrap>
          </StyledLogoWrapper>

          <SliderWrap className={isSetting ? 'slide' : ''}>
            <StyledSettingContainer>
              <StyledSettingTitle>설정</StyledSettingTitle>
              <StyledSettingBoxWrapper>
                {defaultSettings.map((item, idx) => (
                  <StyledSettingBox key={`setting_box_${idx}`}>
                    <StyledSetting direction='left'>
                      <Box sx={{ fontWeight: 'bold', fontSize: '1.125rem' }}>{item.title}</Box>
                      <Box sx={{ color: '#bcbcbc', fontSize: '1.125rem' }}>{item.subtitle}</Box>
                    </StyledSetting>
                    <StyledSetting direction='right'>
                      <ButtonGroup
                        index={idx}
                        height={'2.25rem'}
                        defaultType={item.value ? 'left' : 'right'}
                        type='pc'
                        onClick={onClickSettingButton}
                        sx={{ width: 0.5, minWidth: 0, padding: 0 }}
                      />
                    </StyledSetting>
                  </StyledSettingBox>
                ))}
              </StyledSettingBoxWrapper>
            </StyledSettingContainer>

            <StyledSettingContainer>
              <Box className='mode-box'>
                <Checkbox checked={fullScreen} onClick={openFullScrren} disabled={fullScreen} />
                <Typography
                  component='span'
                  onClick={openFullScrren}
                  sx={{ cursor: fullScreen ? 'inherit' : 'pointer' }}
                >
                  전체모드
                </Typography>
              </Box>
              <StyledInputWrap
                sx={{ input: { fontSize: attendanceNumber.length > 0 ? '3.5rem !important' : '1.5rem' } }}
              >
                <InputNormal
                  id='modal_pc_input'
                  type='text'
                  value={attendanceNumber}
                  onChange={handleInput}
                  onKeyDown={handleKeyDown}
                  autoFocus={true}
                  placeholder={'출결번호'}
                />
              </StyledInputWrap>
              <StyledListContainer>
                <StyledButtonWrapper>
                  <ButtonGroup
                    height={'100%'}
                    defaultType={selectedButton}
                    type='pc2'
                    onClick={onClickListButton}
                    sx={{
                      '&.MuiButtonGroup-grouped.MuiButtonGroup-groupedOutlinedPrimary': {
                        width: 0.5,
                        minWidth: 0,
                        height: 1,
                        fontSize: '1.25rem',
                        lineHeight: '1.25rem',
                        borderTopLeftRadius: '0.75rem',
                        borderTopRightRadius: '0.75rem',
                        borderBottomLeftRadius: '0',
                        borderBottomRightRadius: '0',
                        textAlign: 'center',
                      },
                      '&.MuiButton-outlined': {
                        backgroundColor: '#f3f3f3 !important',
                        borderColor: '#f3f3f3 !important',
                      },
                    }}
                  />
                </StyledButtonWrapper>
                <Box
                  sx={{
                    width: '100%',
                    height: 'calc(100% - 3.75rem)',
                    border: `1px solid`,
                    borderColor: '#f1f1f1',
                    borderTop: 'none',
                  }}
                >
                  <ListSliderWrap className={selectedButton}>
                    <StyledListWrapper>
                      {startStudentList.length > 0 ? (
                        startStudentList.map((item, index) => (
                          <Fragment key={`pc_attendance_list_${index + 1}`}>
                            <StyledWrap direction={'left'}>
                              <Box sx={{ minWidth: '5%', marginRight: '0.25rem' }}>{`${item.no}.`}</Box>
                              <Box
                                sx={{
                                  width: '55%',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  // textAlign: 'center',
                                }}
                              >{`${item.rname}`}</Box>
                            </StyledWrap>
                            <StyledWrap direction={'center'}>
                              <Box
                                sx={{
                                  width: '51.5%',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  textAlign: ' center',
                                  marginRight: '2.25rem',
                                }}
                              >{`${item.uname}`}</Box>
                            </StyledWrap>
                            <StyledWrap direction={'right'}>
                              <Box sx={{ minWidth: '30%' }}>{item.time}</Box>
                            </StyledWrap>
                          </Fragment>
                        ))
                      ) : (
                        <Fragment>
                          <StyledWrap sx={{ width: '100%', height: '100%' }} direction={'center'}>
                            <Box sx={{ minWidth: '30%', textAlign: 'center', color: '#c8c8c8' }}>
                              등원 내역이 없습니다.
                            </Box>
                          </StyledWrap>
                        </Fragment>
                      )}
                    </StyledListWrapper>
                    <StyledListWrapper>
                      {endStudentList.length > 0 ? (
                        endStudentList.map((item, index) => (
                          <Fragment key={`pc_attendance_list_${index + 1}`}>
                            <StyledWrap direction={'left'}>
                              <Box sx={{ minWidth: '5%', marginRight: '0.25rem' }}>{`${item.no}.`}</Box>
                              <Box
                                sx={{
                                  width: '55%',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  // textAlign: 'center',
                                }}
                              >{`${item.rname}`}</Box>
                            </StyledWrap>
                            <StyledWrap direction={'center'}>
                              <Box
                                sx={{
                                  width: '51.5%',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  textAlign: ' center',
                                  marginRight: '2.25rem',
                                }}
                              >{`${item.uname}`}</Box>
                            </StyledWrap>
                            <StyledWrap direction={'right'}>
                              <Box sx={{ minWidth: '30%' }}>{item.time}</Box>
                            </StyledWrap>
                          </Fragment>
                        ))
                      ) : (
                        <Fragment>
                          <StyledWrap sx={{ width: '100%', height: '100%' }} direction={'center'}>
                            <Box sx={{ minWidth: '30%', textAlign: 'center', color: '#c8c8c8' }}>
                              하원 내역이 없습니다.
                            </Box>
                          </StyledWrap>
                        </Fragment>
                      )}
                    </StyledListWrapper>
                  </ListSliderWrap>
                </Box>
              </StyledListContainer>
            </StyledSettingContainer>
            {/* )} */}
          </SliderWrap>
        </StyledModalPcContainer>
      </ModalCustomDefault>
      <ModalCheckPw
        visible={passwordModalVisible}
        onClose={() => {
          setPasswordModalVisible(false);
          setUpdateLock(false);
        }}
        onSubmit={checkPassword}
      />
      <ModalSelect
        visible={modalSelectContents.visible}
        data={modalSelectContents.data}
        currentInput={modalSelectContents.currentInput}
        onCancel={onCancelSelectModal}
        onClick={() => clearModalSelect()}
        onChange={(value: ModalSelectContentsType[]) => checkClassId(value)}
      />
    </>
  );
}

export default ModalPc;
